export default (duration: number): string => {
  const minutes: number = Math.floor(duration / 60);
  const seconds: number = Math.round(duration % 60);

  return minutes + ':' + (seconds >= 10 ? seconds : '0' + seconds);
};
